import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8dbb0276"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-amap-search" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))

import {
  inject, markRaw, ref, onBeforeUnmount, onMounted, toRaw,
} from 'vue'
import { EventEmitter } from 'events'


export default /*#__PURE__*/_defineComponent({
  __name: 'app-amap-search',
  props: {
  location: {
    type: Array,
    default: undefined,
  },
  address: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props


const searchText = ref<string>('')
const searchData = ref<Array<any>>([])

const emitter = inject<EventEmitter>('$map-emitter')
const $amap = inject<any>('$amap')

let amap:any
let placeSearch :any
emitter?.once('init', (_map) => {
  amap = markRaw(_map)
  placeSearch = new AMap.PlaceSearch({
    map: amap,
  })
})

const onChangeSearch = async () => {
  const autoComplete = new AMap.Autocomplete()
  autoComplete.search(searchText.value, (status:any, result:any) => {
    if (status !== 'complete') {
      // instance.proxy?.$message.error('')
      searchData.value = []
      return
    }
    searchData.value = result.tips
  })
}

const searchItem = (item:any) => {
  if (!placeSearch) {
    placeSearch = new AMap.PlaceSearch({
      map: amap,
    })
  }
  placeSearch.setCity(item.adcode)
  placeSearch.search(item.name) // 关键字查询查询
  searchData.value = []
}
// 清除搜索结果
const clearSearch = () => {
  placeSearch?.clear()
}

onMounted(() => {
  amap = toRaw($amap.value)
})
onBeforeUnmount(() => {
  clearSearch()
})


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_input, {
      class: "search-input",
      modelValue: searchText.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
      placeholder: "地图搜索",
      onInput: onChangeSearch,
      clearable: "",
      "prefix-icon": "Search",
      onClear: clearSearch
    }, null, 8, ["modelValue"]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchData.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          key: item.id,
          onClick: ($event: any) => (searchItem(item))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_tooltip, {
              content: item.name,
              placement: "top",
              "open-delay": "1000"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["content"])
          ]),
          _hoisted_5
        ], 8, _hoisted_3))
      }), 128))
    ], 512), [
      [_vShow, searchData.value && searchData.value.length>0]
    ])
  ]))
}
}

})